<template>
    <div class="locations">
        <transition>
            <PointerHelper
                :key="idx"
                :caption="locations.data[idx].name"
                v-if="idx !== -1 && idx !== null"
            />
        </transition>
        <!-- <transition>
            <SelectedHelper
                :key="selectedIdx"
                :idx="selectedIdx"
                v-if="selectedIdx !== -1 && selectedIdx !== null"
            />
        </transition> -->
        <CountryButton
            :caption="page.countrysearch"
            class="country-button"
            @click="isRegionListOpened = true"
        />
        <transition>
            <CountryList
                v-if="data.length && isRegionListOpened && regionList.length > 0"
                @bu="setBu"
                @country="setCountry"
                @region="setRegion"
                @close="close"
                @specializedsubsidiaries="setSS"
                :current-country="currentCountry"
                :current-region="currentRegion"
                :region-list="regionList"
                :country-list="countryList"
                :busines-units="businesUnits"
                :current-bu="currentBu"
                class="country-list"
                :specializedsubsidiaries="specializedsubsidiaries"
            />
        </transition>
        <transition mode="out-in">
            <CountryDetails
                v-if="data.length && currentCountry > -1 && currentBu.id"
                @close="setCountry(-1)"
                :data="countryDetails"
                :bu="currentBu"
                :key="currentBu.id"
                class="country-details"
            />
        </transition>
    </div>
</template>
<script>
import CountryButton from '@/views/Contact/components/CountryButton'
import CountryList from '@/views/Contact/components/CountryList'
import CountryDetails from '@/views/Contact/components/CountryDetails'
import PointerHelper from '@/views/Contact/components/PointerHelper'
// import SelectedHelper from '@/views/Contact/components/SelectedHelper'
import { getFilters } from '@/store/api/index'
import { locations } from '@/store/index.js'
export default {
    components: {
        CountryButton,
        CountryList,
        CountryDetails,
        PointerHelper,
        // SelectedHelper
    },
    props: {
        businesUnits: {
            type: Array
        },
        page: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            isRegionListOpened: false,
            locations,
            currentBu: {},
            specializedsubsidiaries: false
        }
    },
    computed: {
        idx() {
            return this.locations.idx
        },
        selectedIdx() {
            return this.locations.selectedIdx
        },
        data() {
            return this.locations.regions
        },
        currentCountry: {
            get() {
                return this.locations.currentCountry

            },
            set(idx) {
                this.locations.currentCountry = idx
            }
        },
        currentRegion: {
            get() {
                return this.locations.currentRegion
            },
            set(idx) {
                this.locations.currentRegion = idx
            }
        },
        regionList() {
            return this.locations.regions.map(([country], id) => ({
                id,
                name: country.region
            }))
        },
        countryList() {
            return this.data.length && this.currentRegion > -1 ? this.data[this.currentRegion].map(data => {
                const bu = this.businesUnits.filter(_ => _.country === data.id).sort((a, b) => (a.name.localeCompare(b.name, 'fr')) * 2 - 1)
                return{ name: data.name, id: data.id, bu }
            }).filter(_ => _.bu.length > 0) : []
        },
        countryDetails() {
            if (this.data.length && this.currentCountry > -1) {
                const countryData = locations.data.find(countryData => countryData.id === this.currentCountry) || {}
                return Object.assign(
                    { country: countryData.name },
                    JSON.parse(JSON.stringify(countryData.details || {}))
                )
            } else {
                return null
            }
        }
    },
    watch: {
        '$route.params.locale': 'init',
        currentCountry(country) {
            if(country > -1) {
                const current = locations.data.find(_ => _.id === country)
                const idx = this.regionList.map(_ => _.name).indexOf(current.region)
                this.setRegion(idx)
                const currentCountry = this.countryList.find(_ => _.id === country)
                if(currentCountry && currentCountry.bu.length === 1) {
                    this.currentBu = currentCountry.bu[0]
                } else {
                    this.currentBu = {}
                    this.isRegionListOpened = true
                }
            }
        }
    },
    mounted() {
        this.$parent.app.bindPaning(this.$el)
    },
    beforeDestroy() {
        this.$parent.app.unbindPaning(this.$el)
    },
    methods: {
        close(opened = false){
            this.isRegionListOpened = opened
            this.setRegion(-1)
            this.setCountry(-1)
            this.currentBu = {}
        },
        setRegion(region) {
            this.currentRegion = region
        },
        setCountry(country) {
            const idx = locations.data.map(_ => _.id).indexOf(country)
            this.$parent.app.selectIndex(idx)
            this.currentCountry = country
        },
        setSS(value) {
            this.specializedsubsidiaries = value
        },
        setBu(id) {
            const bu = this.businesUnits.find(_ => _.id === id)
            const idx = locations.data.map(_ => _.id).indexOf(bu.country)
            this.$parent.app.selectIndex(idx)
            this.currentCountry = bu.country
            this.currentBu = bu
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.locations
    height: 100vh
    position: absolute
    top: 0
    left: 0
    width: 100vw
.country-button
    position: absolute
    left: 188px
    bottom: 5.7407407407vh
    @include media-breakpoint-down($hd)
        left: 9.6%
    @include media-breakpoint-down($lg)
        left: 9.6%
    @include media-breakpoint-down($sm)
        left: 9.6%
        bottom: 6.25%
        right: 9.6%
        margin-bottom: 4px
.country-list
    position: absolute
    left: 188px
    bottom: 5.7407407407vh
    height: 70vh
    width: auto
    max-width: 512px
    right: 50px
    @include media-breakpoint-down($hd)
        left: 9.6%
    @include media-breakpoint-down($md)
        left: 9.6%
        right: 9.6%
    @include media-breakpoint-down($sm)
        bottom: 6.25%
        margin-bottom: 4px
.country-details
    position: absolute
    right: 50px
    top: 50%
    width: 512px
    transform: translateY(-50%)
    @include media-breakpoint-down($sm)
        position: fixed
        right: 0
        top: 0%
        transform: none
        bottom: 0
        left: 0
        width: auto
        z-index: 60
</style>
